import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Grid, Responsive } from 'semantic-ui-react';
import _ from 'lodash';

import { InputField, SelectField } from 'Common/SemanticWrapper';
import { IMPORT_INGREDIENT_FORM_NAME } from 'Common/FormEnum';
import { ImportIngredientsFieldEnum as Fields } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import {
  IMPORT_TYPE_MAP,
  FILE_DELIMITER_OPTIONS,
  IMPORT_TYPE_OPTIONS,
} from 'Common/Constants';
import { Dropzone } from 'Components/forms/Dropzone';
import { TitledCard } from 'Components/';
import { generateHeaderList } from 'Common/Components/ImportPreview/helpers';

import * as ImportIngSelectors from '../state/selectors';
import { UPDATE_KEY_OPTIONS } from '../helpers/Constants';

const YES_NO_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

class ImportIngredientForm extends Component {
  static propTypes = {
    fileData: PropTypes.array,
  };

  static defaultProps = {
    fileData: [],
  };

  state = {
    showIngFieldMappingModal: false,
  };

  showIngFieldMappingModal = show => () => {
    this.setState({ showIngFieldMappingModal: show });
  };

  onDrop = files => {
    const { change, previewImportIngredient } = this.props;
    if (files[0] === undefined || files[0] === 0) {
      return;
    }
    const file = files[0];

    change(Fields.File, file);
    previewImportIngredient(file);
  };

  renderImportInput() {
    const {
      formValues,
      savedImportConfigOptions,
      change,
      savedImportConfigsMap,
      ingredientColumns,
    } = this.props;

    const importType = formValues[Fields.ImportType];
    let inputProps = {};

    switch (importType) {
      case IMPORT_TYPE_MAP.CREATE_NEW.value:
        inputProps = {
          component: InputField,
          label: 'Name of configuration to be saved',
          name: Fields.ConfigName,
        };
        break;
      case IMPORT_TYPE_MAP.LOAD_SAVED.value:
        inputProps = {
          component: SelectField,
          label: 'Select a saved configuration',
          options: savedImportConfigOptions,
          name: Fields.LoadedConfigId,
          onChange: (e, id) => {
            const savedConfig = _.get(savedImportConfigsMap, id);

            change(
              Fields.SelectedFieldList,
              generateHeaderList(
                savedConfig[Fields.SelectedFieldList],
                ingredientColumns.length
              )
            );
            change(Fields.IncludeHeaders, savedConfig[Fields.IncludeHeaders]);
            change(Fields.Delimiter, savedConfig[Fields.Delimiter]);
            change(
              Fields.CanBeUsedOnMenus,
              savedConfig[Fields.CanBeUsedOnMenus]
            );
            change(Fields.UpdateKey, savedConfig[Fields.UpdateKey]);
          },
        };
        break;
      default:
        break;
    }

    if (Object.keys(inputProps).length < 1) {
      return null;
    }

    return (
      <Grid.Row>
        <Grid.Column>
          <Field {...inputProps} />
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const { fileData, formValues } = this.props;

    return (
      <React.Fragment>
        <TitledCard title="Import Settings">
          <Responsive as={Grid} minWidth={1401}>
            <Grid.Row>
              <Grid.Column width={9} className="input-group--input-group">
                <ReduxFormButtonGroup
                  label="Import Type"
                  options={IMPORT_TYPE_OPTIONS}
                  formName={IMPORT_INGREDIENT_FORM_NAME}
                  fieldName={Fields.ImportType}
                />
                {this.renderImportInput()}
              </Grid.Column>
              <Grid.Column width={3} className="input-group--input-group">
                <ReduxFormButtonGroup
                  label="Can Be Used on Menus"
                  options={YES_NO_OPTIONS}
                  formName={IMPORT_INGREDIENT_FORM_NAME}
                  fieldName={Fields.CanBeUsedOnMenus}
                />
              </Grid.Column>
              <Grid.Column width={4} className="input-group--input-group">
                <Field
                  component={SelectField}
                  label="Update existing ingredients by key:"
                  options={UPDATE_KEY_OPTIONS}
                  name={Fields.UpdateKey}
                />
              </Grid.Column>
            </Grid.Row>
          </Responsive>
          <Responsive as={Grid} maxWidth={1400}>
            <Grid.Row>
              <Grid.Column width={16} className="input-group--input-group">
                <ReduxFormButtonGroup
                  label="Import Type"
                  options={IMPORT_TYPE_OPTIONS}
                  formName={IMPORT_INGREDIENT_FORM_NAME}
                  fieldName={Fields.ImportType}
                />
                {this.renderImportInput()}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4} className="input-group--input-group">
                <ReduxFormButtonGroup
                  label="Can Be Used on Menus"
                  options={YES_NO_OPTIONS}
                  formName={IMPORT_INGREDIENT_FORM_NAME}
                  fieldName={Fields.CanBeUsedOnMenus}
                />
              </Grid.Column>
              <Grid.Column width={12} className="input-group--input-group">
                <Field
                  component={SelectField}
                  label="Update existing ingredients by key:"
                  options={UPDATE_KEY_OPTIONS}
                  name={Fields.UpdateKey}
                />
              </Grid.Column>
            </Grid.Row>
          </Responsive>
        </TitledCard>
        <TitledCard title="File Configuration Settings">
          <Grid>
            <Grid.Row>
              <Grid.Column width={6} className="input-group--input-group">
                <ReduxFormButtonGroup
                  label="File Delimiter"
                  options={FILE_DELIMITER_OPTIONS}
                  formName={IMPORT_INGREDIENT_FORM_NAME}
                  fieldName={Fields.Delimiter}
                  disabled={Boolean(formValues[Fields.File])}
                />
              </Grid.Column>
              <Grid.Column width={10} className="input-group--input-group">
                <ReduxFormButtonGroup
                  label="Does the first row container header information?"
                  options={YES_NO_OPTIONS}
                  formName={IMPORT_INGREDIENT_FORM_NAME}
                  fieldName={Fields.IncludeHeaders}
                />
              </Grid.Column>
            </Grid.Row>
            {Array.isArray(fileData) && fileData.length < 1 && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <div>
                    <label>Select CSV file</label>
                    <Dropzone
                      accept=".csv,.txt"
                      activeClassName="file--dropzone--active"
                      className="file--dropzone"
                      multiple={false}
                      name={Fields.File}
                      onDrop={this.onDrop}
                    >
                      <p>
                        Drag and drop the csv file here <br />
                        <small>or double click to select file</small>.
                      </p>
                    </Dropzone>
                  </div>
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </TitledCard>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  formValues: ImportIngSelectors.getImportIngFormValues(state),
  savedImportConfigOptions: ImportIngSelectors.getSavedImportOptions(state),
  savedImportConfigsMap: ImportIngSelectors.getSavedImportConfigsMap(state),
  ingredientColumns: ImportIngSelectors.getIngredientColumns(state),
});

ImportIngredientForm = connect(mapStateToProps)(
  reduxForm({
    form: IMPORT_INGREDIENT_FORM_NAME,
    destroyOnUnmount: false,
  })(ImportIngredientForm)
);

export { ImportIngredientForm };



// WEBPACK FOOTER //
// ./src/pages/importingredients/components/ImportIngredientForm.js